<div class="add_img_border" (click)="close.emit();"></div>
<div class="add_img_window border_shadow">
    <svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail close_right" (click)="close.emit();">
        <use href="../../../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
    </svg>
    <div class="historyTitle color-no2Pencil lato-regular font-size-18" cvLocalizedText langSection="Users" langKey="Upload_Image">
        Upload Image
    </div>
    <div class="add_img_content_container">
        <div class="pt-5 h-100">
            <cv-img-crop (imgChange)="updateCroppedImage($event)"></cv-img-crop>
        </div>
    </div>
    <div class="d-flex justify-content-end mr-4 mt-2">
        <button type="button" class="btn btn-text mr-2" (click)="imageCancel()"
                cvLocalizedText langSection="Users" langKey="Cancel_Button">
            Cancel
        </button>
        <button type="button" class="btn btn-primary" id="upload_img_save" (click)="updateUserImage()"
                cvLocalizedText langSection="Users" langKey="Save_Button" [disabled]="saveDisabled()">
            Save
        </button>
    </div>
</div>
